<template>
  <!-- <a-button type="link" @click="toEdit">去检查单详情</a-button> -->
  <div class="body-c">
    <div class="search" ref="searchRef">
      <CollapseTop :showBtm="data.showBtm" @moreClick="moreClick">
        <template v-slot:search>
          <div style="display: flex; align-items: center">
            <a-input
              class="search-input"
              v-model:value="listQuery.adPlanId"
              size="large"
              placeholder="随访计划ID"
              allowClear
              @input="inputR($event, 'adPlanId', 3)"
              :maxlength="data.maxlength"
            />
            <a-input
              class="search-input"
              v-model:value="listQuery.checklistId"
              size="large"
              placeholder="检查单ID"
              allowClear
              @input="inputR($event, 'checklistId', 3)"
              :maxlength="data.maxlength"
            />
            <a-input
              class="search-input"
              v-model:value="listQuery.clinicalName"
              size="large"
              placeholder="临观活动名称"
              allowClear
              :maxlength="data.maxlength"
            />
            <a-input
              class="search-input"
              v-model:value="listQuery.patientId"
              size="large"
              placeholder="患者ID"
              allowClear
              @input="inputR($event, 'patientId', 3)"
              :maxlength="data.maxlength"
            />
            <a-input
              class="search-input"
              v-model:value="listQuery.patientProfileSearchKey"
              size="large"
              placeholder="就诊人姓名"
              allowClear
              @input="inputR($event, 'patientProfileSearchKey', 1)"
              :maxlength="data.maxlength"
            />
            <a-button class="search-button" size="large" @click="resetQuery">重置</a-button>
            <a-button class="search-button" size="large" type="primary" @click="searchList">
              搜索
            </a-button>
          </div>
        </template>

        <template v-slot:showSearch>
          <a-input
            class="search-input"
            v-model:value="listQuery.patientName"
            size="large"
            placeholder="患者姓名"
            @input="inputR($event, 'patientName', 1)"
            allowClear
            :maxlength="data.maxlength"
          />
          <a-select
            size="large"
            v-model:value="listQuery.recommendType"
            class="search-select"
            allowClear
            placeholder="处方类型"
          >
            <a-select-option
              v-for="option in data.prescriptionType"
              :value="option.value"
              :key="option.value"
            >
              <span>{{ option.text }}</span>
            </a-select-option>
          </a-select>
          <a-select
            size="large"
            v-model:value="listQuery.formStatus"
            class="search-select"
            allowClear
            placeholder="表单状态"
          >
            <a-select-option
              v-for="option in data.formStatus"
              :value="option.value"
              :key="option.value"
            >
              <span>{{ option.text }}</span>
            </a-select-option>
          </a-select>
          <a-range-picker
            size="large"
            v-model:value="listQuery.editTime"
            :placeholder="['编辑开始日期', '编辑结束日期']"
            allowClear
            format="YYYY-MM-DD"
            class="search-picker"
            valueFormat="YYYY-MM-DD HH:mm:ss"
          />
          <a-range-picker
            size="large"
            v-model:value="listQuery.uploadTime"
            :placeholder="['上传开始日期', '上传结束日期']"
            allowClear
            format="YYYY-MM-DD"
            class="search-picker"
            valueFormat="YYYY-MM-DD HH:mm:ss"
          />
        </template>
      </CollapseTop>
    </div>
    <!-- data.tableTop -->
    <a-table
      class="table"
      :pagination="data.pagination"
      :rowKey="(record, index) => index"
      :columns="data.columns"
      :data-source="data.list"
      @showSizeChange="onShowSizeChange"
      @change="onChangePage"
      :scroll="{ x: '100%', y: `calc(100vh - ${data.sHeight}px )` }"
      :transformCellText="({ text }) => (text ? text : '--')"
    >
      <template #checklistId="slotData">
        <div class="idClass" @click="toCheckDetail(slotData.record.checklistId)">
          {{ slotData.record.checklistId }}
        </div>
      </template>
      <template #adPlanId="slotData">
        <div
          class="idClass"
          @click="slotData.record.adPlanId > 0 ? tosfDetil(slotData.record) : ''"
        >
          {{
            slotData.record.adPlanId && slotData.record.adPlanId > 0
              ? slotData.record.adPlanId
              : '--'
          }}
        </div>
      </template>
      <!-- <template #editName="slotData">
        {{ slotData.record.editName }}
      </template> -->
      <template #handle="slotData">
        <a-button type="link" @click="toEdit(slotData.record)">编辑</a-button>
      </template>
    </a-table>

    <a-modal
      v-model:visible="data.Detail"
      :width="1059"
      title="检查单详情"
      :ok-button-props="{
        disabled: data.jsValue ? false : true
      }"
      :bodyStyle="data.bodyStyle"
      :footer="null"
    >
      <checklistDetail :checklistId="data.checklistId" :visible="data.Detail"></checklistDetail>
    </a-modal>
    <the-detail
      v-model:visible="data.detailVisible"
      :id="data.pId"
      :recordType="data.recordType"
      serialNumber=""
    />
  </div>
</template>
<script>
export default {
  name: 'Checklist'
}
</script>

<script setup>
import { inputRule } from '@/utils/validate'
import { reactive, onMounted, ref, onActivated, computed } from 'vue'
import { columnsExamine, paginationConfig, formStatus, prescriptionType } from './config.js'
import { getCheckList } from '@/api/HealthRecord/index.js'
import { useRouter } from 'vue-router'
import CollapseTop from '@/components/CollapseTop/index'
import checklistDetail from '../HealthRecord/checklistDetail.vue'
import TheDetail from '@/components/TheDetail/index.vue'
import { useFilterCache } from '@/hooks/useFilterCache'
import { FILTER_CACHE_PAGE_KEYS } from '@/constants/filterCache'
import { useStore } from 'vuex'
import { cloneDeep } from 'lodash-es'
// import moment from 'moment'
const router = useRouter()
const store = useStore()
const data = reactive({
  sHeight: 260,
  maxlength: 30,
  detailVisible: false,
  pId: 0,
  recordType: '',
  prescriptionType: prescriptionType,
  formStatus: formStatus,
  columns: columnsExamine,
  list: [],
  Detail: false,
  checklistId: '',
  pagination: paginationConfig,
  scrollPages: 0,
  defaultQuery: {
    adPlanId: null, //随访计划id
    checklistId: null, //检查单ID
    clinicalName: null, //临观活动名称
    patientId: null, //患者ID
    patientProfileSearchKey: null, //就诊人姓名
    patientName: '', //患者姓名
    recommendType: null, //处方类型
    formStatus: null, //表单状态
    editTime: [], //编辑时间
    uploadTime: [], //上传时间
    pageIndex: 1,
    pageSize: 20
  },
  showBtm: false,
  tableTop: 0,
  bodyStyle: {
    padding: '16px 24px 18px 24px'
  }
})
// const showTimeObj = reactive({
//   format: 'HH:mm:ss',
//   defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')]
// })
// const headerRef = ref(null)
const searchRef = ref(null)
const listQuery = reactive({
  ...data.defaultQuery
})
const defaultCacheQuery = {
  ...cloneDeep(data.defaultQuery),
  showBtm: false,
  current: paginationConfig.current,
  pageSize: paginationConfig.pageSize
}
const { initFromCache, updateCache } = useFilterCache({
  pageKey: FILTER_CACHE_PAGE_KEYS.CHECKLIST_LIST,
  userId: computed(() => store.state.user.userId),
  defaultParams: defaultCacheQuery,
  normalize: params => ({
    ...cloneDeep(defaultCacheQuery),
    ...cloneDeep(params),
    editTime: Array.isArray(params?.editTime) ? params.editTime : [],
    uploadTime: Array.isArray(params?.uploadTime) ? params.uploadTime : []
  })
})

const applyCacheQuery = cacheQuery => {
  Object.assign(listQuery, data.defaultQuery, cacheQuery)
  data.showBtm = !!cacheQuery.showBtm
  data.pagination.current = cacheQuery.current || paginationConfig.current
  data.pagination.pageSize = cacheQuery.pageSize || paginationConfig.pageSize
}

const persistCache = () => {
  updateCache({
    ...listQuery,
    showBtm: data.showBtm,
    current: data.pagination.current,
    pageSize: data.pagination.pageSize
  })
}

const moreClick = () => {
  data.showBtm = !data.showBtm
  persistCache()
  getHeight()
}
const getHeight = () => {
  setTimeout(() => {
    data.sHeight = searchRef.value.clientHeight + 204
  }, 0)
}
const toCheckDetail = checklistId => {
  data.checklistId = checklistId + ''
  data.Detail = true
}
const tosfDetil = e => {
  console.log('去随访详情', e)
  data.recordType = 'visit'
  data.pId = e.adPlanId
  data.detailVisible = true
}
const getList = () => {
  for (const key in listQuery) {
    if (listQuery[key]) {
      if (listQuery[key].length > data.maxlength) {
        listQuery[key] = listQuery[key].substring(0, data.maxlength)
      }
    }
  }
  getCheckList(listQuery).then(res => {
    data.list = res[0].list
    data.pagination.current = res[0].currPage
    data.pagination.pageSize = res[0].pageSize
    data.pagination.total = res[0].totalCount
    data.pagination.showTotal = () => `共${res[0].totalCount}条`
  })
}
// 编辑
const toEdit = examineData => {
  router.push({
    path: '/formEdit',
    query: {
      checklistId: examineData.checklistId
    }
  })
}
// // 改变当前页
const onChangePage = page => {
  listQuery.pageIndex = page.current
  listQuery.pageSize = page.pageSize
  data.pagination.current = page.current
  data.pagination.pageSize = page.pageSize
  persistCache()
  getList()
}
// // 改变页码值
const onShowSizeChange = (current, pageSize) => {
  console.log(current, pageSize)
}

//控制输入规则
function inputR(e, key, type) {
  listQuery[key] = inputRule(e.target.value, type)
}

// const onDateChange = (date, dateString) => {
//   listQuery[dateString] = [
//     date[0].format('YYYY-MM-DD HH:mm:ss'),
//     date[1].format('YYYY-MM-DD  HH:mm:ss')
//   ]
// }
const resetQuery = () => {
  data.showBtm = false
  Object.assign(listQuery, data.defaultQuery)
  data.pagination.current = paginationConfig.current
  data.pagination.pageSize = paginationConfig.pageSize
  persistCache()
  getList()
}
const searchList = () => {
  data.showBtm = false
  listQuery.pageIndex = 1
  data.pagination.current = 1
  persistCache()
  getHeight()
  getList()
}
onActivated(() => {
  getList()
  goHistoryPosition()
})
//跳到详情页后保留原来滚动条位置
const historyHeight = ref(null)
const goHistoryPosition = () => {
  const e = document.getElementsByClassName('ant-table-body')[0]
  e.scrollTop = historyHeight.value
}
//滚动位置
window.addEventListener(
  'scroll',
  () => {
    var e = document.getElementsByClassName('ant-table-body')[0]
    if (e && e.scrollTop) {
      historyHeight.value = e.scrollTop
    }
  },
  true
)
onMounted(() => {
  applyCacheQuery(initFromCache())
})
</script>
<style scoped lang="scss">
.body-c {
  height: 100%;
  position: relative;
  ::v-deep(.ant-table-pagination.ant-pagination) {
    float: left;
  }
}
.table {
  padding: 20px 20px;
  // position: absolute;
  overflow: scroll;
  ::v-deep(.ant-btn) {
    padding: 0;
  }
  .idClass {
    color: #1890ff;
    cursor: pointer;
  }
}

.search {
  display: flex;
  position: relative;
  align-items: center;
  background-color: #fff;
  .search-input {
    width: 210px;
    margin-right: 12px;
    margin-bottom: 8px;
  }
  .search-tip {
    display: inline-block;
    line-height: 40px;
    font-size: 16px;
    margin-right: 12px;
    margin-bottom: 8px;
  }
  .search-select {
    width: 208px;
    margin-right: 12px;
    margin-bottom: 8px;
  }
  .search-picker {
    margin-right: 12px;
    width: 320px;
    margin-bottom: 8px;
  }
  .search-button {
    margin-right: 12px;
    border-radius: 4px;
    margin-bottom: 8px;
  }
}
</style>
